<template>
  <v-page page="Dashboards" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-4 pt-3 pb-0>
      <!-- HEADER -->
      <v-layout justify-start row align-center mt-0 mb-0 style="min-height: 46px;">
        <v-flex align-center>
          <div
            class="text-xs-left align-center"
            style="font-size: 20px; font-weight: 600;"
          >Dashboards</div>
        </v-flex>
        <v-flex align-center xs8>
          <v-layout row>
            <v-flex xs4>
              <v-autocomplete
                class="pt-0 mr-3 mt-0"
                hide-details
                :items="ddlCategory"
                v-model="filters.CategoryID"
                item-text="Text"
                item-value="Value"
                label="Category"
                clearable
                @change="filterDashboards"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                class="pt-0 mr-3 mt-0"
                hide-details
                :items="ddlOwner"
                v-model="filters.Owner"
                item-text="Text"
                item-value="Value"
                label="Owner"
                clearable
                @change="filterDashboards"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                class="pt-0 mr-3 mt-0"
                hide-details
                :items="ddlDataFrequency"
                v-model="filters.DataFrequency"
                item-text="Text"
                item-value="Value"
                label="Data Gathering"
                clearable
                @change="filterDashboards"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs4 ml-5>
              <v-layout row>
                <v-text-field
                  v-model="search"
                  label="Search"
                  single-line
                  hide-details
                  class="align-center mt-0 pt-0"
                  @keyup.enter="filterDashboards"
                ></v-text-field>
                <v-btn @click="filterDashboards" icon mx-2 class="TierButton my-0 py-0">
                  <v-icon style="font-size:18px">fa-search</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex></v-flex>
      </v-layout>
      <!-- END HEADER -->
      <!-- DASHBOARD TABLE -->
      <v-data-table
        :headers="headers"
        :items="dashboards"
        :item-key="dashboards.index"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="totalRecords"
        @update:pagination="paginationUpdated"
        hide-details
        class="striped-table no-pagination-btn"
      >
        <template slot="items" slot-scope="props">
          <tr :key="props.index" :class="categoryClass(props.item.CategoryName)">
            <td class="text-xs-left px-0">
              <text-highlight
                :queries="searchHighlight"
              >{{ props.item["CategoryName"] | uppercase }}</text-highlight>
            </td>
            <td class="text-xs-left px-0">
              <text-highlight :queries="searchHighlight">{{ props.item["DashboardID"] }}</text-highlight>
            </td>
            <td class="text-xs-left px-0">
              <text-highlight :queries="searchHighlight">{{ props.item["Name"] }}</text-highlight>
            </td>
            <td class="text-xs-left px-0">
              <text-highlight :queries="searchHighlight">{{ props.item["SubmitBy"] }}</text-highlight>
            </td>
            <td class="text-xs-left px-0">
              <text-highlight
                :queries="searchHighlight"
              >{{ props.item["DataFrequency"] | uppercase }}</text-highlight>
              <bar-chart-container
                v-if="props.item.DBID == DBID"
                :ref="'dashboard'+props.item.DBID"
                :DBID="props.item.DBID.toString()"
                :isMounted="true"
                :display="false"
              ></bar-chart-container>
            </td>
            <td class="text-xs-left px-0">
              <text-highlight :queries="searchHighlight">{{ formatType(props.item.Type)}}</text-highlight>
            </td>

            <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
              <v-layout v-if="props.item.IsPermitted">
                <v-flex>
                  <router-link
                    style="text-decoration: none"
                    :to="openViewDashboard(props.item)"
                  >VIEW</router-link>
                  <a @click="exportToPDF(props.item)" class="ml-3">
                    <span>PDF</span>
                  </a>
                  <a @click="exportToExcel(props.item)" class="ml-3">
                    <span>EXCEL</span>
                  </a>
                </v-flex>
              </v-layout>
            </td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="red lighten-3"
          icon="fa-exclamation-triangle"
        >
          Your
          search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-layout row justify-start align-center>
            <v-flex xs2 style="font-size: 14px;">
              <span v-show="hasFilter">No records found for the applied filters</span>
            </v-flex>
            <v-flex xs8>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template slot="actions-append">
        <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
        </template>
      </v-data-table>
      <!-- END USERS TABLE -->

      <v-btn
        color="primary"
        @click="resetDashboardList"
        v-show="showResetBtn && !loading"
        style="margin-top: -40px;"
      >Reset</v-btn>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import "@/assets/css/main.css";
import moment from "moment";
import TextHighlight from "vue-text-highlight";
import BarChartContainer from "../../components/Dashboards/BarChartContainer.vue";
import Spinner from "../../components/Spinner.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Dashboards",
  components: {
    VPage,
    "text-highlight": TextHighlight,
    BarChartContainer,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    search: "",
    loading: true,

    showResetBtn: false,
    filters: {},
    filtersChanged: false,

    dashboards: [],

    ddlCategory: [],
    ddlDataFrequency: [],
    ddlOwner: [],

    DBID: null,
    isMounted: false,

    searchHighlight: "",
    totalRecords: 0,

    rowsPerPageItems: [
      30,
      45,
      60,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      sortBy: "DBID",
      page: 1,
      totalItems: 0
    },
    headers: [
      {
        text: "Category",
        value: "CategoryName",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Dashboard ID",
        value: "DashboardID",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Name",
        value: "Name",
        // sortable: false,
        width: "28%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Owner",
        value: "SubmitBy",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Data Gathering",
        value: "DataFrequency",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Type",
        value: "Type",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc",
        // sortable: false,
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "21%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ],

    breadcrumb: [
      {
        text: "Dashboards",
        disabled: false,
        href: "#/dashboards"
      },
      {
        text: "All",
        disabled: true,
        href: "#/dashboards"
      }
    ]
  }),
  methods: {
    async initialize() {
      this.getDropDownLists();
      await this.paginationUpdated();

      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    getDropDownLists() {
      axios.get("/api/Dashboards/GetDashboardsDDLs/").then(res => {
        this.ddlCategory = res.data.ddlCategory;
        this.ddlOwner = res.data.ddlOwner;
        this.ddlDataFrequency = res.data.ddlDataFrequency;
      });
    },

    async resetDashboardList() {
      this.loading = true;

      this.filters = {};
      this.filtersChanged = true;
      this.searchHighlight = "";
      this.search = "";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async filterDashboards() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery();
      await this.paginationUpdated();
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Dashboards/GetPagedDashboardList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search,
              totalRecords: this.totalRecords
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.dashboards = response.data.dashboards;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },

    openViewDashboard(item) {
      return "/dashboard-view/" + item.DBID;
    },
    updateSearchQuery() {
      var route = Object.assign({}, this.$route);
      var path = route.path;
      var query = route.query;
      var oldQuery = Object.assign({}, query);
      oldQuery.search = this.search;
      this.$router.push({ path: path, query: oldQuery });
    },
    exportToExcel(item) {
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Dashboards/dashboardtoexcel/" + item.DBID,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          var fileName =
            item.DashboardID + " - " + item.Name + "." + currentDate + ".xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    async exportToPDF(item) {
      this.$refs.spinner.spinOn();
      this.DBID = await item.DBID.toString();
      await setTimeout(() => {
        this.$refs[`dashboard${item.DBID}`].export2PDF().then(() => {
          this.$refs.spinner.spinOff();
        });
      }, 3000);
    },
    categoryClass(item) {
      if (item) {
        var categoryClass;
        categoryClass = item
          .split(" ")
          .join("")
          .replace("/", "");
        return categoryClass;
      }
    },
    formatType(item) {
      //items == props.item.Type
      if (item) {
        if (item.length > 0) {
          var delimiter = ", ";
          var types = item.join(delimiter);
          if (item.length > 1) {
            var index = types.lastIndexOf(delimiter);
            types =
              types.substring(0, index) +
              " & " +
              types.substring(index + delimiter.length);
            return types;
          } else {
            return types;
          }
        }
      }
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    uppercase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },
  created() {
    this.initialize();
  }
};
</script>
<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/deep/ tr:hover {
  background-color: #eeeeee !important;
}
/deep/ table.v-table tbody tr.AccountsReceivables:nth-child(odd) {
  background-color: #ecf0f8;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.BilledRevenue:nth-child(odd) {
  background-color: #fdf1ea;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.BusinessOperations:nth-child(odd) {
  background-color: #f6f6f6;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.Sales:nth-child(odd) {
  background-color: #fff8e5;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.ServiceOperations:nth-child(odd) {
  background-color: #eef5fb;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(odd) {
  background-color: #f0f7ec;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(odd) {
  background-color: #ffe3e6;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(odd) {
  background-color: #fff5cd;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(odd) {
  background-color: #d9e2f3;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(odd) {
  background-color: #fbe5d6;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(odd) {
  background-color: #ededed;
  /* background-color:#dbdbdb; */
}
/deep/ table.v-table tbody tr.AccountsReceivables:nth-child(even) {
  background-color: #ecf0f885;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.BilledRevenue:nth-child(even) {
  background-color: #fdf1ea81;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.BusinessOperations:nth-child(even) {
  background-color: #f6f6f679;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.Sales:nth-child(even) {
  background-color: #fff8e581;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.ServiceOperations:nth-child(even) {
  background-color: #eef5fb7e;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(even) {
  background-color: #f0f7ec81;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(even) {
  background-color: #ffe3e67e;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(even) {
  background-color: #fff5cd81;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(even) {
  background-color: #d9e2f37e;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(even) {
  background-color: #fbe5d680;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(even) {
  background-color: #ededed80;
  /* background-color:#dbdbdb; */
}
</style>